export const PhotoDisclaimer =
  'These photos are for sales consultation purposes only. You are not authorized to use these for any other purpose.';
